import { Users } from "@gogive/types";
import { API_V2 } from "@/config/api";
import { apiRequest } from "@gogive/services";
import {
  AuthorizeRequest,
  RequestNewTokenRequest,
  createAuthService,
} from "@gogive/auth";

const authService = createAuthService<Users>({
  apiBase: API_V2 ?? "", 
  authMode: "charity",
  apiRequest,
});

export const { routes } = authService;

export const requestNewToken = ({ token }: RequestNewTokenRequest) =>
  authService.requestNewToken({ token });

export interface SignInRequest {
  email: string;
}

export const signIn = ({ email }: SignInRequest) => authService.signIn({ email });

export const signOut = () => authService.signOut();

export const authorize = (input: AuthorizeRequest) => authService.authorize(input);
